import React, { useCallback, useState, useEffect } from "react";
import { Field, ErrorMessage, getIn } from "formik";
import TextError from "./TextError";
import { makeStyles } from "@material-ui/core";

function Select(props) {
  const [warn, setWarn] = useState(false);
  const { label, name, options, ...rest } = props;
  const [selected, setSelected] = useState();
  const classes = useStyles();

  const errorStyle = useCallback(() => {
    if (getIn(props.error, props.name)) {
      setWarn(true);
      console.log("error=> true");
    } else {
      setWarn(false);
    }
  }, [props.error, props.name]);

  useEffect(() => {
    !warn && errorStyle();
  }, [errorStyle, warn]);

  return (
    <div className="form-control">
      <label htmlFor={name}>{label && label}</label>
      <Field
        as="select"
        id={name}
        name={name}
        {...rest}
        value={selected}
        onChange={(e) => setSelected(e.target.value)}
        className={warn ? classes.errorContent : classes.selectContent}
      >
        {options.map((option) => {
          return (
            <option key={option.value} value={option.value}>
              {option.value}
            </option>
          );
        })}
      </Field>
      <ErrorMessage component={TextError} name={name} />
    </div>
  );
}

const useStyles = makeStyles((theme) => {
  return {
    selectWrapper: {
      width: "100%",
    },
    inputLabel: {
      paddingLeft: 18,
      top: "-7px",
    },
    errorText: {
      paddingLeft: 18,
      top: "-7px",
      color: theme.palette.error.main,
    },
    selectContent: {
      width: "100%",
    },
    errorContent: {
      width: "100%",
      borderColor: theme.palette.error.main,
      borderStyle: "solid",
      borderWidth: "1px",
    },
  };
});
export default Select;
